import { readJson, writeStorage } from '@/shared/lib/storage';

/**
 * Итоги встречи после чтения не меняются, а возвращаются к ним и через неделю: готовая карточка лежит на устройстве
 * и открывается мгновенно, пока сервер тихо перепроверяет. Хранится только законченное (не «идёт запись/расшифровка»).
 */
const PREFIX = 'meeting.card.';
const KEEP = 200;

const key = (userId: string, workspaceId: string, id: string) => `${PREFIX}${userId}.${workspaceId}.${id}`;

export function readStoredMeeting(userId: string, workspaceId: string, id: string): unknown {
  return readJson(key(userId, workspaceId, id)) ?? undefined;
}

export function writeStoredMeeting(userId: string, workspaceId: string, id: string, data: unknown): void {
  try {
    const keys = Object.keys(localStorage).filter((k) => k.startsWith(PREFIX));
    // Не копим бесконечно: при переполнении выбрасываем самые старые по порядку ключей.
    if (keys.length >= KEEP && !keys.includes(key(userId, workspaceId, id))) for (const k of keys.slice(0, keys.length - KEEP + 1)) writeStorage(k, null);
  } catch {
    // Хранилище недоступно — карточка просто не запомнится.
  }
  writeStorage(key(userId, workspaceId, id), JSON.stringify(data));
}

/** При выходе из аккаунта итоги чужих встреч на устройстве не остаются. */
export function clearStoredMeetings(): void {
  try {
    for (const k of Object.keys(localStorage)) if (k.startsWith(PREFIX)) localStorage.removeItem(k);
  } catch {
    // Нечего чистить.
  }
}

/** Сервер отказал (доступ отозван, запись удалена): старую копию больше не показываем. */
export function removeStoredMeeting(userId: string, workspaceId: string, id: string): void {
  writeStorage(key(userId, workspaceId, id), null);
}
